<template>
    <div class="XGXX">
        <div class="title">
            <span style="color: #6681EA;">修改信息</span>
        </div>
        <div class="floor">
            <el-form label-position="right" label-width="150px" :model="form" style="zoom: 1.2;" :rules="rules" ref="form">
                <el-form-item label="头像：" prop="cover">
                    <ImageUpload :limit="1" @input="getImgUrl" :value="form.cover" />


                </el-form-item>
                <el-form-item label="姓名：" prop="name">
                    <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
                </el-form-item>

                <el-form-item label="身份证号：" prop="idcard">
                    <el-input v-model="form.idcard" placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item label="性别：">
                    <el-radio-group v-model="form.sex">
                        <el-radio :label="'0'">男</el-radio>
                        <el-radio :label="'1'">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="地址：">
                    <el-input v-model="form.address" placeholder="请输入地址"></el-input>
                </el-form-item>

                <el-form-item label="电子邮箱：">
                    <el-input v-model="form.email" placeholder="请输入电子邮箱"></el-input>
                </el-form-item>




            </el-form>
        </div>
        <div class="coomit" @click="submitForm">
            <span>保存</span>
        </div>
    </div>
</template>

<script>
import { getUserInfoByUserId, updateUserInfo } from "../../api/login.js";
export default {
    data() {
        return {

            form: {
                cover: '',//头像
                name: '',//姓名
                idcard: '',//	身份证号
                address: '',//	地址
                email: '',//	邮箱
            },
            // 表单校验
            rules: {

                name: [
                    { required: true, message: "姓名不能为空", trigger: "blur" },
                ],
                idcard: [
                    { required: true, message: "身份证号不能为空", trigger: "blur" },
                    { message: '身份证号格式错误', pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, trigger: 'blur' }
                ],
            }

        }
    },
    methods: {
        // 获取上传图片路径
        getImgUrl(res) {
            console.log(res);
            this.form.cover = res;
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    updateUserInfo(this.form).then((response) => {
                        this.$modal.msgSuccess("修改成功");
                        this.$parent._data.option = '个人信息'
                    });

                }
            });
        },
    },
    mounted() {
        getUserInfoByUserId().then(res => {
            this.form = res.data.data ? res.data.data : {
                cover: '',//头像
                name: '',//姓名
                idcard: '',//	身份证号
                address: '',//	地址
                email: '',//	邮箱
            }
        })
    },
}
</script>

<style scoped>
* {
    box-sizing: border-box;
    padding: 0;
    /* margin: 0; */
}

.el-form-item__content {
    position: relative;
}

.el-input__inner {
    width: 400px;
}

.el-form-item__label {
    font-size: 20px !important;
}

.XGXX {
    box-shadow: 0px 0px 25px 4px rgba(90, 90, 90, 0.12);
    padding: 24px 30px;
    width: 100%;
    padding-bottom: 48px;
}

.title {
    padding-bottom: 20px;
    border-bottom: 1px solid #6681EA;
    font-size: 30px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #6681EA;
    margin-bottom: 20px;
}

.floor {
    display: flex;
}

.floor>.option {
    font-size: 18px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #303133;
}

.place {
    border: 1px solid #ddd;
    width: 100%;
    display: flex;
    height: 38px;
    cursor: pointer;
    border-radius: 4px;
    padding: 0 15px;
    align-items: center;
    justify-content: space-between;
    position: relative;
    color: #606266;
}

.province {
    border: 1px solid #ddd;
    width: 100%;
    display: flex;
    height: 38px;
    cursor: pointer;
    border-radius: 4px;
    padding: 0 15px;
    align-items: center;
    justify-content: space-between;
    color: #606266;
    position: relative;
}

.bank {
    border: 1px solid #ddd;
    width: 100%;
    display: flex;
    height: 38px;
    cursor: pointer;
    border-radius: 4px;
    padding: 0 15px;
    align-items: center;
    justify-content: space-between;
    color: #606266;
    position: relative;
}

.account {
    border: 1px solid #ddd;
    width: 100%;
    display: flex;
    height: 38px;
    cursor: pointer;
    border-radius: 4px;
    padding: 0 15px;
    align-items: center;
    justify-content: space-between;
    color: #606266;
    position: relative;
}

.placeList {
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: column;
    transform: translate(-4%, 60%);
    z-index: 10000;
    background-color: #fff;
    /* padding: 14px 16px; */
    border-radius: 4px;
    max-height: 200px;
    overflow: auto;
    z-index: 10000;
}

.plaDetail:hover {
    background-color: #eee;
    padding: 0 16px;
}

.provinceList {
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: column;
    transform: translate(-4%, 60%);
    z-index: 10000;
    background-color: #fff;
    /* padding: 14px 16px; */
    border-radius: 4px;
    max-height: 200px;
    overflow: auto;
    z-index: 10000;
}

.proDetail:hover {
    background-color: #eee;
    padding: 0 16px;
}

.bankList {
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: column;
    transform: translate(-4%, 60%);
    z-index: 10000;
    background-color: #fff;
    /* padding: 14px 16px; */
    border-radius: 4px;
    max-height: 200px;
    overflow: auto;
    z-index: 10000;
}

.bankDetail:hover {
    background-color: #eee;
    padding: 0 16px;
}

.accountList {
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: column;
    transform: translate(-4%, 60%);
    z-index: 10000;
    background-color: #fff;
    /* padding: 14px 16px; */
    border-radius: 4px;
    max-height: 200px;
    overflow: auto;
    z-index: 10000;
}

.accDetail:hover {
    background-color: #eee;
    padding: 0 16px;
}

.coomit {
    width: 400px;
    text-align: center;
    background-color: #6681EA;
    color: #fff;
    font-size: 22px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    padding: 16px 0;
    border-radius: 5px;
    margin-left: 150px;
    margin-top: 8px;
    cursor: pointer;
}
</style>
